export const validEmailRegex =
    /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;

export const validPhoneRegex = /^\+?[0-9\s\-().]{7,20}$/;

export const validUserCodeRegex = /^\d{6}$/;
